"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PillSelectionItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _precheckIcons = require("../utils/precheck-icons");
var _pillItem = _interopRequireDefault(require("../common/pill-item"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _bulletList = _interopRequireDefault(require("../common/bullet-list"));
const Radio = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Radio",
  class: "pc-r1glowib",
  vars: {
    "r1glowib-3": [({
      selected
    }) => selected ? `0 0 0 calc(${_intents.default.ux.controlChosen.borderWidth} - 1px) ${_intents.default.ux.controlChosen.borderColor}` : `0 0 0 0 transparent`]
  }
});
function PillSelectionItem({
  id,
  _name,
  tag,
  productTagLabel,
  title,
  description,
  list,
  priceEyebrow,
  price,
  priceDescription,
  selected,
  a11yAttributes
}) {
  const trackingAttributes = _patternLibraryUtils.tracking.create(_name, true, false);
  const termContent = [{
    text: productTagLabel,
    type: 'tag',
    size: 'sm',
    dataCy: 'pill-tag'
  }, {
    text: title,
    type: 'title',
    size: 0,
    dataCy: 'pill-title'
  }];
  if (description) {
    termContent.push({
      text: description,
      type: 'paragraph',
      size: -1,
      dataCy: 'pill-desc'
    });
  }
  if (list && list.length > 0) {
    termContent.push({
      node: /*#__PURE__*/_react.default.createElement(_bulletList.default, {
        list: list,
        dataCy: "pill"
      }),
      type: 'node',
      dataCy: 'pill-list-container'
    });
  }
  const priceContent = [{
    text: tag,
    type: 'tag',
    size: 'sm',
    design: 'warning'
  }, {
    text: priceEyebrow,
    type: 'paragraph',
    size: -1,
    dataCy: 'pill-price-eyebrow'
  }, {
    text: price,
    type: 'title',
    size: 2,
    dataCy: 'pill-price'
  }, {
    text: priceDescription,
    type: 'paragraph',
    size: -1,
    dataCy: 'pill-price-desc'
  }];
  return /*#__PURE__*/_react.default.createElement(Radio, (0, _extends2.default)({
    id: `id-${id}`
  }, id && {
    'data-pc-enum': id
  }, {
    "data-cy": "pill-selection-item",
    "aria-label": title
  }, a11yAttributes, _name ? trackingAttributes : {}, {
    selected: selected,
    "data-partial": "precheck"
  }), /*#__PURE__*/_react.default.createElement(_pillItem.default, {
    leftPanelContent: termContent,
    rightPanelContent: priceContent,
    icon: (0, _precheckIcons.getIcon)(selected)
  }));
}
PillSelectionItem.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  productTagLabel: _propTypes.default.string,
  title: _propTypes.default.string,
  tag: _propTypes.default.string,
  description: _propTypes.default.string,
  list: _propTypes.default.arrayOf(_propTypes.default.shape({
    content: _propTypes.default.string.isRequired
  })),
  priceEyebrow: _propTypes.default.string,
  price: _propTypes.default.string,
  priceDescription: _propTypes.default.string,
  selected: _propTypes.default.bool,
  a11yAttributes: _propTypes.default.object
};